import React from "react";
import { Link } from "react-router-dom";
import ScrollReveal from "../Components/ScrollReveal/ScrollReveal";
import KineticText from "../Components/KineticText";

const MeetTheTeam = () => {
  // Array of employee objects
  const teamMembers = [
    {
      name: "John Doe",
      role: "CEO",
      image: "https://via.placeholder.com/150",
      description: "John has over 20 years of experience in the industry and leads our team with passion and vision.",
    },
    {
      name: "Jane Smith",
      role: "CTO",
      image: "https://via.placeholder.com/150",
      description: "Jane is an expert in technology and innovation, ensuring our products stay ahead of the curve.",
    },
    {
      name: "Michael Brown",
      role: "Head of Marketing",
      image: "https://via.placeholder.com/150",
      description: "With a flair for creativity, Michael drives our marketing strategies and ensures our brand shines.",
    },
    {
      name: "Emily Johnson",
      role: "Product Manager",
      image: "https://via.placeholder.com/150",
      description: "Emily is dedicated to understanding customer needs and delivering exceptional products.",
    },
    {
      name: "David Wilson",
      role: "Lead Developer",
      image: "https://via.placeholder.com/150",
      description: "David leads our development team, focusing on building innovative solutions.",
    },
    {
      name: "Sarah Brown",
      role: "UX/UI Designer",
      image: "https://via.placeholder.com/150",
      description: "Sarah creates user-friendly designs that enhance the customer experience.",
    },
  ];

  return (
    <div className="overflow-x-hidden">
      {/* Banner Section */}
      <ScrollReveal>
        <KineticText as="p" splitBy="char" className="mt-[50px] mb-[50px] text-black text-5xl text-center heading-font font-bold">
          MEET THE TEAM
        </KineticText>
      </ScrollReveal>
      <ScrollReveal variant="clip" distance={0}>
        <div className="w-full h-[50vh] bg-[#96D4E9] flex justify-center items-center">
          <KineticText as="p" splitBy="word" className="w-[80%] text-center text-5xl sm:m-10 text-white heading-font">
            A Team of Experts Committed to Excellence
          </KineticText>
        </div>
      </ScrollReveal>

      {/* Team Introduction Section */}
      <ScrollReveal className="w-[90%] lg:w-[70%] mx-auto my-10 flex flex-col" direction="up">
        <KineticText as="p" splitBy="word" className="text-4xl my-6 font-bold text-center heading-font">
          Meet Our Dedicated Team
        </KineticText>
        <p className="text-2xl my-3 text-center">
          Our team comprises industry experts who are passionate about delivering the best products and services to our customers. Together, we strive for excellence in everything we do.
        </p>
      </ScrollReveal>

      {/* Team Members Section */}
      <ScrollReveal className="w-[90%] lg:w-[70%] mx-auto my-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10" stagger={0.1}>
        {teamMembers.map((member, index) => (
          <div key={index} className="bg-white rounded-lg shadow-md p-6 flex flex-col items-center hover:-translate-y-2 transition duration-300">
            <img
              className="w-[150px] h-[150px] rounded-full mb-4 object-cover"
              src={member.image}
              alt={member.name}
            />
            <p className="text-2xl font-bold">{member.name}</p>
            <p className="text-lg text-gray-500">{member.role}</p>
            <p className="text-center mt-3">{member.description}</p>
          </div>
        ))}
      </ScrollReveal>

      {/* Conclusion Section */}
      <ScrollReveal className="w-[90%] lg:w-[70%] mx-auto my-10 flex flex-col" direction="up">
        <KineticText as="p" splitBy="word" className="text-4xl my-6 font-bold text-center heading-font">
          Join Us in Our Journey
        </KineticText>
        <p className="text-2xl my-3 text-center">
          Our team is always growing. We are looking for talented individuals to join us in our mission to create outstanding products.
        </p>
        <p className="text-2xl my-3 text-center">
          If you are interested in becoming a part of our family, check out our job openings and apply today!
        </p>
        <Link to="/join-the-team" className="text-center py-4 bg-[#96D4E9] text-white hover:bg-black ease-in-out duration-300 w-[260px] mx-auto my-10 rounded-full font-bold shadow-lg hover:shadow-xl transform hover:-translate-y-1">JOIN US</Link>
      </ScrollReveal>
    </div>
  );
};

export default MeetTheTeam;
